import React from "react";
import PerUnitSaasOptions from "./PerUnitSaasOptions";
import style from "./QuoteSaasItems.module.css";
import SaasItem from "./SaasItem";

export default function QuoteSaasItems({saasItems}) {
  return saasItems.map(item => (
    <div className={style.root} key={item.key}>
      <SaasItem item={item} />
      <PerUnitSaasOptions item={item} />
    </div>
  ));
}
